var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"font-bold px-8 py-1 text-base rounded hover:brightness-90 active:brightness-75 transition-all",class:_vm.variantStyles[_vm.variant],attrs:{"type":"button"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }